import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { SelectButtonOptionClickEvent } from 'primeng/selectbutton';
import { LabelCode } from '@app/shared/interfaces/label-code.interface';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { CoreModule } from '@app/core/core.module';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-personal-data-info',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './personal-data-info.component.html',
    styleUrl: './personal-data-info.component.scss',
})
export class PersonalDataInfoComponent {

    private appData = inject(AppService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    personalDataTitle = "features.personalData.personalDataTitle";
    personalDataInfoSubtitle = "features.personalData.personalDataInfo.personalDataInfoSubtitle";
    personalDataName = "features.personalData.personalDataInfo.name";
    personalDataLastName = "features.personalData.personalDataInfo.lastName";
    personalDataSecondName = "features.personalData.personalDataInfo.secondName";

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;
    genderMale: boolean = false;

    formGroup!: FormGroup;

    genderOptions: LabelCode[] = [];
    selectedGenderOptions!: LabelCode;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private saveDataService: SaveDataService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(3);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.createForm();
        this.setValuesForm(this.appData.data.userData);

        this.formIsValid();
    }

    createForm() {
        this.genderOptions = [
            { label: 'Hombre', code: 'MR' },
            { label: 'Mujer', code: 'MRS' },
        ];

        this.formGroup = this.fb.group({
            gender: new FormControl(this.selectedGenderOptions ? this.selectedGenderOptions.code : 'MR'),
            textName: new FormControl('', [Validators.required, Validators.minLength(1)]),
            textFirst: new FormControl('', [Validators.required, Validators.minLength(1)]),
            textSecond: new FormControl('', [Validators.required, Validators.minLength(1)]),
        });
    }

    setValuesForm(value?: any) {
        if (value != undefined && value.personalDataInfo != undefined) {
            this.formGroup = this.fb.group({
                gender: new FormControl(this.identifierGender(value.personalDataInfo.gender ? value.personalDataInfo.gender : '')),
                textName: new FormControl(value.personalDataInfo.textName ? value.personalDataInfo.textName : '', [
                    Validators.required,
                    Validators.minLength(1),
                ]),
                textFirst: new FormControl(value.personalDataInfo.textFirst ? value.personalDataInfo.textFirst : '', [
                    Validators.required,
                    Validators.minLength(1),
                ]),
                textSecond: new FormControl(value.personalDataInfo.textSecond ? value.personalDataInfo.textSecond : '', [
                    Validators.required,
                    Validators.minLength(1),
                ]),
            });
        }
    }

    getGender(value: any = undefined) {
        if (value != undefined) this.selectedGenderOptions = value;
    }

    identifierGender(value : string) {

        const woman = ["SR", "MRS", "FEMALE"];
        const man = ["MR", "SEÑOR", "MALE"];
        const val = value.toUpperCase().trimStart().trimEnd();

        if(!value || value === ''){
            return '';
        }

        if(man.some(valor => valor.includes(val))) {
            console.log("IDENTIFICO MAN: ", value); //TODO QUITAR
            return "MR";
        } else if (woman.some(valor => valor.includes(val))){
            console.log("IDENTIFICO WOMAN: ", value); //TODO QUITAR
            return "MRS";
        } else {
            return "";
        }
    }

    //-------------------------//
    //-------GENDER--------//
    //-------------------------//

    onChangeGender(event: SelectButtonOptionClickEvent) {
        this.getGender(event.option);
        this.formIsValid();
    }

    onChangeName(event: Event) {
        this.formIsValid();
    }

    onChangeSecond(event: Event) {
        this.formIsValid();
    }

    onChangeFirst(event: Event) {
        this.formIsValid();
    }

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'personal-data-info');
        this.router.navigate(['/main/step/identification'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'personal-data-info');
        this.router.navigate(['/main/step/personal-data-birth'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
